import type { ProjectResponseInList } from '@/backend/types'
import { serializeParentProperty } from '@/modules/Project/serializer'
import type { ProjectInList } from '@/modules/Projects/useProjects'

export const serializeProjectInList = (project: ProjectResponseInList): ProjectInList => ({
  id: project.id,
  name: project.name,
  workspaceId: project.workspace_id,
  parentProperty: project.parent_property
    ? serializeParentProperty(project.parent_property, project.workspace_id)
    : null,
  parentFolderId: project.parent_folder_id,
  coverImageUrls: project.cover_image_urls,
  updatedAt: project.updated_at,
  createdAt: project.created_at,
  description: project.description,
  type: project.type,
})
